import { AnimatePresence, motion } from 'framer-motion';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { failXTime, numberOfAnswers } from './Constants';

export const answerScoreStyle = {
	fontSize: '24px',
	fontWeight: 'bold',
	letterSpacing: '1.5px',
};

const AnswerGrid = ({
	easyMode = false,
	useStaticQuery = '',
	query,
	answers,
	roundOver,
	correctAnswers,
	tester = false,
	giveUp,
}: {
	easyMode?: boolean;
	useStaticQuery?: string;
	query: string;
	answers?: string[];
	roundOver: boolean;
	correctAnswers: boolean[];
	tester?: boolean;
	giveUp: boolean;
}) => (
	<ul
		key="answerList"
		style={{
			display: 'inline-block',
			margin: useStaticQuery ? '0 0 var(--single)' : '0',
			padding: 0,
			width: '100%',
		}}>
		{Array.from({ length: tester ? 13 : numberOfAnswers }, (__, val) => (
			<li
				key={`answer_${val}`}
				className="answer"
				style={{
					border: 0,
					display: 'flex',
					height: '35px',
					lineHeight: '35px',
					margin: 0,
					overflow: 'hidden',
					padding: '0 var(--single)',
					position: 'relative',
				}}>
				<AnimatePresence>
					<motion.div
						key={`answerDiv_${query}`}
						animate={{
							left: 0,
						}}
						exit={{
							left: '1000px',
							transition: {
								delay: 0,
								duration: 0.5,
							},
						}}
						initial={{
							left: '-1000px',
						}}
						style={{
							border: 0,
							display: 'flex',
							flex: 1,
							height: '25px',
							lineHeight: '25px',
							margin: 0,
							padding: '5px var(--single)',
							position: 'absolute',
							width: 'calc(100% - var(--double))',
						}}
						transition={{
							delay: 0.1 * val,
							duration: 0.5,
						}}>
						<StaticImage
							alt={`Answer #${val}`}
							className="hideOnMobile"
							imgStyle={{ display: 'inline-block', width: '20px' }}
							loading="eager"
							objectFit="scale-down"
							placeholder="blurred"
							src="../../images/search.svg"
							style={{
								display: 'inline-block',
								marginRight: 'var(--half)',
							}}
						/>
						<div className="hideOnMobile" style={{ marginRight: '0.25em' }}>
							{query}
						</div>
						<div
							style={{
								fontSize:
									answers &&
									val in answers &&
									answers[val].length + query.length > 55
										? '13px'
										: 'inherit',
								fontWeight: 'bold',
								marginRight: 'var(--single)',
								position: 'relative',
								whiteSpace: 'nowrap',
								zIndex: '98',
							}}>
							{answers?.[val] && (
								<OutboundLink
									href={
										'https://www.google.com/search?q=' +
										encodeURIComponent(query + ' ' + answers[val])
									}
									target="_blank">
									{answers[val]}
								</OutboundLink>
							)}
							<motion.div
								key={`reveal_${query}`}
								animate={{
									width: !roundOver && !correctAnswers[val] ? '100%' : 0,
								}}
								initial={{
									width: '100%',
								}}
								style={{
									backgroundColor: 'var(--blue)',
									height: '100%',
									position: 'absolute',
									right: 0,
									top: 0,
									userSelect: 'none',
								}}
								transition={{
									bounce: 0,
									delay:
										roundOver && !giveUp ? failXTime / 1000 + 0.1 * val : 0,
									duration: 0.5,
									type: 'spring',
								}}
							/>
						</div>
						<div
							style={{
								...answerScoreStyle,
								color: correctAnswers[val] ? 'var(--blue)' : 'var(--gray)',
								flex: 1,
								overflow: 'hidden',
								position: 'absolute',
								right: 'var(--single)',
								textAlign: 'right',
							}}>
							{(easyMode === false || val < 8) &&
								((10 - val) * 1000).toLocaleString()}
						</div>
					</motion.div>
				</AnimatePresence>
			</li>
		))}
	</ul>
);
export default AnswerGrid;
